import React from 'react';
import { useTheme } from '@mui/material/styles';
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';

const ApexBarChart = ({ category, data, roleTypes, selectedBolge, selectedServis }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const { primary } = theme.palette.text;
    const darkLight = theme.palette.dark.light;
    const grey200 = theme.palette.grey[200];

    const series = data || [];

    const options = {
        chart: {
            type: 'bar',
            height: 350,
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    const selectedEmployeeType = category[config.dataPointIndex];
                    if (roleTypes === true) {
                        const redirectUrl = `/EmployeeMain/1?selectedBolge=${selectedBolge}&selectedServis=${selectedServis}&selectedEmployeeType=${selectedEmployeeType}`;
                        navigate(redirectUrl);
                    } else {
                        const redirectUrl = `/Employee`;
                        navigate(redirectUrl);
                    }
                },
                dataPointMouseEnter: (event) => {
                    event.target.style.cursor = 'pointer';
                },
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#FF9800'],
        xaxis: {
            categories: category || [],
            labels: {
                style: {
                    colors: new Array(category?.length || 0).fill(primary)
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: new Array(data?.[0]?.data?.length || 0).fill(primary)
                }
            }
        },
        grid: {
            borderColor: theme.palette.mode === 'dark' ? darkLight + 20 : grey200
        },
        tooltip: {
            theme: theme.palette.mode === 'dark' ? 'dark' : 'light'
        },
    };

    return (
        <div id="chart">
            <ReactApexChart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

export default ApexBarChart;
